/*
 * *
 *   ~  * Copyright (c) by INFODATA-GROUP. All rights reserved.
 *   ~  * No part of this publication may be reproduced, distributed,
 *   ~  * or transmitted in any form or by any means, including photocopying, recording,
 *   ~  * or other electronic or mechanical methods, without the prior written permission of the publisher,
 *   ~  * except in the case of brief quotations embodied in critical
 *   ~  * reviews and certain other noncommercial uses permitted by copyright law.
 *   ~  * AUTHOR : bs
 *   ~  * DATE : 15/07/2025 15:41
 *
 */

export const BUTTON_TRAFFIC = () => {
  const button = document.createElement('button');
  applyButtonStyle(button);
  applyButtonStyleIsSelected(button, false);
  button.innerHTML = 'Trafic';
  button.style.marginTop = '10px';
  button.style.marginLeft = '-10px';
  button.style.borderBottomRightRadius = '2px';
  button.style.borderTopRightRadius = '2px';
  button.style.minWidth = '50px';
  return button;
};

const applyButtonStyle = (button: HTMLElement) => {
  button.style.background = 'none padding-box rgb(255, 255, 255)';
  button.style.display = 'table-cell';
  button.style.border = '0px';
  button.style.padding = '0px 17px';
  button.style.textTransform = 'none';
  button.style.position = 'absolute';
  button.style.cursor = 'pointer';
  button.style.userSelect = 'none';
  button.style.overflow = 'hidden';
  button.style.textAlign = 'center';
  button.style.height = '40px';
  button.style.verticalAlign = 'middle';
  button.style.fontFamily = 'Roboto, Arial, sans-serif';
  button.style.fontSize = '18px';
  button.style.boxShadow = 'rgba(0, 0, 0, 0.3) 0px 1px 4px -1px';
  button.style.minWidth = '64px';
};

export const applyButtonStyleIsSelected = (
  button: HTMLElement,
  isSelected: boolean,
) => {
  if (!isSelected) {
    button.style.color = 'rgb(86, 86, 86)';
    button.style.fontWeight = 'normal';
    return;
  }
  button.style.color = 'rgb(0, 0, 0)';
  button.style.fontWeight = 'bold';
};
